<template>
  <b-modal
    :id="modalId"
    ref="history-modal"
    hide-footer
    size="xl"
    :title="title"
  >
    <b-table
      class="table-bordered table-hover"
      :fields="fields"
      :items="items"
      :busy="onLoading"
      show-empty
      empty-text="Chưa có lịch sử thay đổi"
    >
      <template v-slot:table-busy>
        <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
      </template>
      <template v-slot:cell(createdAt)="row">
        <span>{{ formatDateTime(row.item.createdAt) }}</span>
      </template>
      <template v-slot:cell(createdByName)="row">
        <span>{{ row.item.createdByName || row.item.createdBy }}</span>
      </template>
      <template v-slot:cell(action)="row">
        <span>{{ actionName(row.item.action) }}</span>
      </template>
      <template v-slot:cell(changes)="row">
        <span v-if="!getChanges(row.item).length" class="text-muted">--</span>
        <ul v-else class="mb-0 pl-4">
          <li v-for="(change, index) in getChanges(row.item)" :key="index">
            <b>{{ change.label || change.field }}:</b>
            <span>{{ displayValue(change.oldValue) }}</span>
            &rarr;
            <span>{{ displayValue(change.newValue) }}</span>
          </li>
        </ul>
      </template>
    </b-table>
    <div class="mt-4">
      <b-button variant="secondary" size="sm" @click="hideModal">Đóng</b-button>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import moment from 'moment';
import { formatDate, makeToastFaile } from '@/utils/common';
import { COMMISSION_HISTORY_ACTION_NAME } from './commission.constants';

const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export default {
  components: {
    VclTable,
  },
  props: {
    modalId: {
      type: String,
      default: 'commission-history-modal',
    },
    title: {
      type: String,
      default: 'Lịch sử thay đổi',
    },
  },
  data() {
    return {
      onLoading: false,
      items: [],
      fields: [
        {
          key: 'createdAt',
          label: 'Thời gian',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'createdByName',
          label: 'Người thực hiện',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'action',
          label: 'Hành động',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'changes',
          label: 'Thay đổi',
          thStyle: { fontWeight: 600, color: '#181c32', width: '55%' },
        },
      ],
    };
  },
  methods: {
    /**
     * @param {String} url endpoint trả về lịch sử, ví dụ
     *   `commission-categories/1/histories`
     */
    show(url) {
      this.items = [];
      this.$refs['history-modal'].show();
      this.fetchHistories(url);
    },
    hideModal() {
      this.$refs['history-modal'].hide();
    },
    fetchHistories(url) {
      this.onLoading = true;
      ApiService.setHeader();
      ApiService.query(url)
        .then(({ data }) => {
          this.items = data.data.data || data.data || [];
        })
        .catch(() => {
          makeToastFaile('Không tải được lịch sử thay đổi!');
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    getChanges(item) {
      if (!item.changes) {
        return [];
      }
      if (Array.isArray(item.changes)) {
        return item.changes;
      }
      try {
        const parsed = JSON.parse(item.changes);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    displayValue(value) {
      if (value === null || value === undefined || value === '') {
        return '(trống)';
      }
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      return value;
    },
    actionName(action) {
      return COMMISSION_HISTORY_ACTION_NAME[action] || '';
    },
    formatDateTime(value) {
      if (!value) {
        return '';
      }
      // Một số API đã trả sẵn chuỗi hiển thị -> giữ nguyên, tránh moment parse sai
      if (moment(value, DATE_TIME_FORMAT, true).isValid()) {
        return value;
      }
      return formatDate(value, DATE_TIME_FORMAT);
    },
  },
};
</script>
